
import axios from "axios";
import React, { Component } from "react";
import MapLocation from '../../components/MapLocationGoogle'
import _ from 'lodash'
import {
  FormGroup,
  Collapse,
  Row,
  Col,
  Label,
  Input,
  FormText,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormFeedback
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import api from "../../utils/axiosApi";
import { Toast } from "../../utils/sweetalert";
import { nameSchema } from "../../utils/validateForm";
import ImageUploader from "../components/imageUpload";
import { days} from "../../utils/filterTags";
import moment from "moment"; 
import { colorsDisp } from "../../utils/const";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const objDays= {
  '1': 'Lunes',
  '2': 'Martes',
  '3': 'Miercoles',
  '4': 'Jueves',
  '5': 'Viernes',
  '6': 'Sabado',
  '7': 'Domingo',
}
class FormAdminPlacesSection extends Component {
  constructor(props) {
    super(props) 
    const calendarData = props.calendarData
    debugger

    var temporadas = [moment().format('YYYY-MM-DD')]
    
    var tempDate =moment().add(1, 'day').format('YYYY-MM-DD') 
    if(calendarData?.workingH) {
      temporadas = Object.keys(calendarData.workingH)
      
      tempDate =moment(temporadas[temporadas.length -1]).add(1, 'day').format('YYYY-MM-DD') 

    }
    this.state = {
      name : calendarData.name,
      nameEn : calendarData?.nameEn || '',
      title : calendarData.title,
      titleEn : calendarData?.titleEn || '',
      idActivity: calendarData._id,
      location : [],
      stars : calendarData.stars,
      temporada: temporadas[temporadas.length -1],
      
      tempDate: tempDate ,
      newHorario: calendarData?.workingH || {
        [moment().format('YYYY-MM-DD')] : {},
      },

      duration: calendarData.duration,
      classes: calendarData.classes,
      tags : calendarData.tags, 
      urlImage: calendarData.urlImg,
      idImg: calendarData.idImg,
      lat: calendarData.lat,
      lon: calendarData.lon,
      
      telf:calendarData.telf || '',
      web:calendarData.web || '',
      
      mail:calendarData.mail || '',
      descriptionEn:calendarData.descriptionEn || '',
      descriptionLarge:calendarData.descriptionLarge || '',
      phrase:calendarData.phrase || '',
      selectedCities: calendarData.location,
      cities: [],
      prices: calendarData.prices || {},
      pricesEn: calendarData.pricesEn || {},
      priceType: calendarData.priceType || '$',

      diaInicio: 1,
      diaFin: 1,
      horaInicio: '06:00',
      horaFin: '23:00',

      
      tempPriceName:'',
      tempPriceNameEn:'',
      tempPriceCost:0,

      image: null,
      tagList:[],
      isOpen: false,
      disabled: false,
      errors: {
        name: false,
        location: false,
        time: false,
        price: false
      }
    }
  }
  async componentDidMount() {
    
    
  }
  handleSubmit = async (e) =>{
    e.preventDefault()
    debugger
        const nameValidation = nameSchema.validate(this.state.name)
        this.setState({disabled: true})
        let newStateError = {...this.state.errors}
        
        if (nameValidation.error) {
            newStateError = {...newStateError, name: true}
        }
        if (!this.state.selectedCities.length === 0 ) {
            
            newStateError = {...newStateError, location: true}
        }
        if (this.state.minTime > this.state.maxTime) {
            
            newStateError = {...newStateError, time: true}
        }
        if (this.state.minPrice > this.state.maxPrice) {
            
            newStateError = {...newStateError, price: true}
        }
        this.setState({errors: newStateError})
         if( nameValidation.error 
          ||this.state.minPrice > this.state.maxPrice 
          || this.state.minTime > this.state.maxTime 
          || !this.state.selectedCities.length === 0 ) 
          {
            this.setState({disabled: false})
            return}
         const formData = new FormData()
          formData.append('file', this.state.image)
          formData.append('upload_preset', 'tripendar')
        try {
          
          const cloudinaryKey = process.env.REACT_APP_CLOUDINARY_KEY || 'drdcye5c'//tripendar/y7supfvk80sxyhyjornj
          var respCloud = undefined
          var urlImg = this.state.urlImage || ''
          var idImg = this.state.idImg || ''
          
          
          if(this.state.idImg && this.state.image ) {
            //TODO: hacer un servicio para eliminar la imagen antes de guardar una nueva
            debugger
              await api.post(`/adminsplaces/deleteImg`, {
                idImg:this.state.idImg
              })
            respCloud = await axios.post(`https://api.cloudinary.com/v1_1/${cloudinaryKey}/image/upload`, formData)
            urlImg = respCloud.data.secure_url
            idImg = respCloud.data.public_id
            
          } else if(!this.state.idImg && this.state.image) {
            respCloud = await axios.post(`https://api.cloudinary.com/v1_1/${cloudinaryKey}/image/upload`, formData)
            urlImg = respCloud.data.secure_url
            idImg = respCloud.data.public_id
          }
          var locationArray= []
          
          this.state.selectedCities.forEach(e => {
            locationArray = locationArray.concat(e.fullName.split(',').map(lo => lo.trim() ))
          })
          const data ={
            name: this.state.name,
            nameEn: this.state.nameEn,
            title: this.state.title,
            titleEn: this.state.titleEn,
            place: locationArray[0],
            location: this.state.selectedCities.map(e=> e._id),
            stars: this.state.stars,
            //minTime: this.state.minTime,
            //maxTime: this.state.maxTime,
            //minPrice: this.state.minPrice,
            //maxPrice: this.state.maxPrice,
            workingH: this.state.newHorario,
            duration: this.state.duration,
            classes: this.state.classes,
            lat: this.state.lat,
            lon: this.state.lon,
            tags: _.uniq(this.state.tags.concat(locationArray)),
            urlImg: urlImg,
            idImg: idImg,
            telf: this.state.telf,
            web: this.state.web,
            mail:this.state.mail,
            priceType: this.state.priceType,
    
            descriptionEn: this.state.descriptionEn,
            descriptionLarge:this.state.descriptionLarge,
            phrase:this.state.phrase,
            prices: this.state.prices,
            pricesEn: this.state.pricesEn,
          }
            debugger
            if(this.state.idActivity) {
              const response = await api.put(`/adminsplaces/modify/${this.state.idActivity}`, data)
              this.props.onEditSuccess?.(response.data.data)
            } else {
              await api.post(`/adminsplaces/set`, data)
            }
          //this.props.history.push('/admin/VerAdmins')
          const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>Actividad editada Exitosamente</p>,
                icon: 'success',
                
            })
            
            this.props.onBack?.()
            this.setState({image: null, urlImg: '', disabled: false})
         } catch (error) {
           //console.log(error)
           const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '15px'}}>algo salio Mal...</p>,
                icon: 'error',
                
            })
            this.setState({disabled: false})
         }
    
  }
  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value })
  }
  handleChangecheck = (e) => {
    debugger
    const tagsCopy= [...this.state.tags]
    if(e.target.value === 'false') {
      tagsCopy.push(e.target.name)
      
    } else {
      const id= tagsCopy.findIndex((ele) => ele===e.target.name)
      tagsCopy.splice(id, 1)
      
    }
    this.setState({tags: tagsCopy})
  }
  handleChangeImg = (file) => {
    this.setState({image: file})
  }
  handleChangeNumber = (e) => {
    const amount = e.target.value.replace(',','.');

    if (!amount || amount.match(/^\d{1,}(\.\d{0,4})?$/)) {
      this.setState({[e.target.name]: (amount) });
    }
  }
  /*handleChangeLngLat = (e) => {
    const fixValue = e.target.value !== '' ? e.target.value.replace(',','.') : '0'
    const value = parseFloat(fixValue)
    this.setState({[e.target.name]: value })

  }*/
  handleChangeCity = async (e) => {
    this.setState({location: e.target.value})
    if(!this.state.disabled) {this.setState({disabled: true})}
    if(e.target.value.length > 3) {
      try {
          this.setState({isOpen: true})
          const resp = await api.get(`/ciudades/getcities?city=${e.target.value}&disabledHide=true`)
          if(resp.data.query === e.target.value) {
              this.setState({cities: resp.data.data})
          }
      } catch (error) {
        this.setState({isOpen: false})
          //console.log(error)
      }
  }else {
    this.setState({isOpen: false})
  }
    /*
    const arraytag = e.target.value.split(';')
    const newarray = arraytag.map((e) => (e.trim()))
    this.setState({[e.target.name]: newarray })*/
  }
  Handleclick = (place, _id) => {
    const selectedCitiescopy = [...this.state.selectedCities]
    selectedCitiescopy.push({fullName: place.toLowerCase(), _id})
    this.setState({location: '', isOpen: false, disabled:false, selectedCities: selectedCitiescopy})
  }
  handleValidateName =(e,n) =>{
    const validation = nameSchema.validate(e)
        if(validation.error) {
            this.setState({errors: {...this.state.errors, [n]: true}})
        } else {
            this.setState({errors: {...this.state.errors, [n]: false}})
        }
  }
  
  handleAddDays() {
    const {horaInicio, horaFin, diaInicio, diaFin } = this.state
    if(diaInicio>diaFin) return
    const newDaysTime ={
      start: horaInicio,
      end: horaFin
    }
    const horario = {...this.state.newHorario}
    horario[this.state.temporada][`${diaInicio}_${diaFin}`]=newDaysTime
    this.setState({newHorario: horario})
    //debugger

  }
  /*getOptions =(e) => {
    const array = []
    for (var i = 0; i < 24; i++) {
      array.push(<option key={`${e}-${i}`} value={i}>{`${i}:00`}</option>)
    }
    return array
  }*/
  handleLonLat = (lonLat) => {
    this.setState({lon: lonLat.lng, lat: lonLat.lat}) //{lon: lonLat.lng, lat: lonLat.lat}
  }

  handleDeleteCity =(index) =>{
    const cities = [...this.state.selectedCities]
    cities.splice(index, 1)
    this.setState({selectedCities: cities})
  }
  render() {
    const temporadas = Object.keys(this.state?.newHorario)
    /*const actEle = tags.act.map((a,i) => {
      return <Col key={`'actCheckbox-${i}`}>
            <FormGroup>
              <Label check className='mr-3 text-capitalize'>{a}:
                <Input 
                className='m-1'
                onChange={this.handleChangecheck} 
                type="checkbox" 
                value={!!this.state[a]}
                name={a} 
                id={a}>
                </Input>
                
              </Label>
            </FormGroup>
            </Col>
  })*/
  const newTags = this.state.tagList.map((a,i) => {
    const isSelected = this.state.tags.includes(a.name)
    return <Col key={`'actCheckbox-${i}`}>
            <FormGroup>
            <Label check className='mr-3 text-capitalize'><div
              
              className=' iconFont'>
              {a.icon?.url && <img src={a.icon.url} alt={a.icon.emoji} />}
              </div>{a.name}:
                <Input 
                className='m-1'
                onChange={this.handleChangecheck} 
                type="checkbox" 
                checked={isSelected}
                value={isSelected}
                name={a.name} 
                id={a.name}>
                </Input>
                
              </Label>
            </FormGroup>
            </Col>
  })
  /*const placTEle = tags.placT.map((a,i) => {
      return <Col key={`'actCheckbox-${i}`}>
      <FormGroup>
        <Label check className='mr-3 text-capitalize'>{a}:
          <Input 
          className='m-1'
          onChange={this.handleChangecheck} 
          type="checkbox" 
          value={!!this.state[a]}
          name={a} 
          id={a}>
          </Input>
          
        </Label>
      </FormGroup>
      </Col>
  })*/
    return (
      <>
      <div className="content">
        <Row>
          <Col md="12">
          <Card>
          <CardHeader>
          <Row>
            <Col>
          <CardTitle tag="h4">Editar</CardTitle></Col>
            <Col><Button onClick={this.props.onBack} disabled={this.state.disabled} color="danger" type="button">
            Volver
          </Button></Col>
          </Row>
          </CardHeader>
      <CardBody>
        <form onSubmit={this.handleSubmit}>
          <FormGroup>
            <Label for="name">Nombre Del Lugar</Label>
            <Input
              onChange={this.handleChange}
              value={this.state.name}
              onBlur={(e) => {this.handleValidateName(e.target.value, e.target.name)}} 
              invalid={this.state.errors.name}
              type="text"
              name="name"
              id="name"
              placeholder="Introduzca el nombre"
            />
            <FormFeedback>El nombre no es Valido</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="nameEn">Nombre Del Lugar Ingles</Label>
            <Input
              onChange={this.handleChange}
              value={this.state.nameEn}
              onBlur={(e) => {this.handleValidateName(e.target.value, e.target.name)}} 
              invalid={this.state.errors.name}
              type="text"
              name="nameEn"
              id="nameEn"
              placeholder="Introduzca el nombre"
            />
            <FormFeedback>El nombre no es Valido</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="estrellas">Estrellas</Label>
            <Input 
              onChange={this.handleChangeNumber} 
                      className='p-0'
              value={this.state.stars}
              type="text" 
              name="stars" 
              id="estrellas">
              </Input>
          </FormGroup>
          
                <Row className='m-0'>
                    
                    <Col className="pl-md-1" md="4">
                    <FormGroup >
                      <Label for="duration">Duracion</Label>
                      <Input 
                      onChange={this.handleChangeNumber} 
                      value={this.state.duration}
                      type="text" 
                      min='1'
                      name="duration" 
                      id="duration">
                      </Input>
                      <FormText color="muted">
                        coloque en cantidad de horas
                      </FormText>
                    </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                      <Label for="phrase">Titulo</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.title}
                      type="text" 
                      name="title" 
                      id="title">
                      </Input>
                    </FormGroup>
                  <FormGroup>
                      <Label for="phrase">Titulo ingles</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.titleEn}
                      type="text" 
                      name="titleEn" 
                      id="titleEn">
                      </Input>
                    </FormGroup>
                    <Row className='m-0'>
                    <Col className="pr-md-1" md="4">
                    
                    <FormGroup>
                      <Label for="mail">correo</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.mail}
                      type="email" 
                      name="mail" 
                      id="mail">
                      </Input>
                    </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="4">
                    <FormGroup >
                      <Label for="telf">Telefono</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.telf}
                      type="text" 
                      name="telf" 
                      id="telf">
                      </Input>
                      <FormFeedback>El precio minimo no puede ser mayor al maximo</FormFeedback>
                    </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="4">
                    <FormGroup >
                      <Label for="web">Pag Web</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.web}
                      type="url" 
                      name="web" 
                      id="web">
                      </Input>
                      <FormFeedback>El precio minimo no puede ser mayor al maximo</FormFeedback>
                    </FormGroup>
                    </Col>
                    
                  </Row>
                  <FormGroup >
                      <Label for="descriptionLarge">Descripcion</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.descriptionLarge}
                      type="textarea" 
                      name="descriptionLarge" 
                      id="descriptionLarge">
                      </Input>
                      <FormFeedback>El precio minimo no puede ser mayor al maximo</FormFeedback>
                    </FormGroup>
                  <FormGroup >
                      <Label for="descriptionLarge">Descripcion en ingles</Label>
                      <Input 
                      onChange={this.handleChange} 
                      value={this.state.descriptionEn}
                      type="textarea" 
                      name="descriptionEn" 
                      id="descriptionEn">
                      </Input>
                      <FormFeedback>El precio minimo no puede ser mayor al maximo</FormFeedback>
                    </FormGroup>
                  

     { /*--------------------------------------------creador de temporadas---------------------------- */}
     { /*--------------------------------------------creador de temporadas---------------------------- */}
                  <Row>
                    <Col className="pr-md-1" md="6">

                      <FormGroup>
                      <Label check className='mr-3'>Añadir nueva temporada
                        <Input 
                        className='m-1'
                        value={this.state.tempDate}
                        min={moment(temporadas[temporadas.length -1 ]).add(1, 'day').format('YYYY-MM-DD')}
                        onChange={(e) => this.setState({tempDate: e.target.value})} 
                        type="date" >
                        </Input>
                      </Label>
                        <Button onClick={() => {
                          const date = this.state.tempDate
                          this.setState({tempDate: moment(date).add(1, 'day').format('YYYY-MM-DD'), newHorario:  {...this.state.newHorario, [date] : {}}})
                        }} size="sm" type='button'>Crear</Button>
                    </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="6">
                    <FormGroup>
                    <Label check className='mr-3'>Seleccione una temporada
                      <Input 
                      className='m-2 p-0'
                      value={this.state.temporada}
                      onChange={(e) => {this.setState({temporada: e.target.value})}} 
                      type="select" >
                      {temporadas.map((e,i) => {
                        if(temporadas.length -1 === i ){
                          return <option value={e} key={`temp-${i}`}>de {e} en adelante</option>
                        } else {
                          return <option value={e} key={`temp-${i}`}>de {e} hasta {temporadas[i+1]}</option>
                        }
                      })}
                      </Input>
                    </Label>
                      <Button disabled={(temporadas.length === 1)} size="sm" type='button' onClick={() => {
                        const newHorarioCopy = {...this.state.newHorario}
                        const temporadasCopy = [...temporadas]
                        if(temporadasCopy.length === 1) return
                        delete newHorarioCopy[this.state.temporada]
                        const id= temporadasCopy.findIndex(e => e === this.state.temporada)
                        temporadasCopy.splice(id,1)
                        this.setState({temporada: temporadasCopy[0], newHorario: newHorarioCopy})
                      }}>Eliminar Temporada</Button>
                  </FormGroup>
                    </Col>
                  </Row>
                  
    {/*--------------------------------nuevos horarios---------------------------------*/}
                  <Row className='justify-content-center m-0'>
                    <Col xs={12} md={12} lg={12}><h2>horario semanal</h2></Col>
                      <Col xs={12} md={12} lg={12} key={`${this.state.temporada}-key`} className='border rounded border-primary p-3 m-1'> 
                                <h2 className='m-0 text-capitalize'>Rango de Dias</h2>
                                  
                                <Row className='m-0'>
                    
                                    <Col className="pl-md-1" md="3">
                                    <FormGroup>
                                                  <Label for={`diaInicio`}>De</Label>
                                                  <Input 
                                                    onChange={this.handleChange} 
                                                            className='p-0'
                                                    value={this.state.diaInicio}
                                                    type="select" 
                                                    name="diaInicio" 
                                                    id={`diaInicio`}>
                                                      <option selected disabled>Seleccione un Dia</option>
                                                      {days.map((e,i) => {
                                                        return <option value={i+1}>{e}</option>
                                                      })}
                                                    </Input>
                                                </FormGroup>
                                    </Col>
                                    <Col className="pl-md-1" md="3">
                                    <FormGroup>
                                                  <Label for={`diaFin`}>A</Label>
                                                  <Input 
                                                    onChange={this.handleChange} 
                                                            className='p-0'
                                                    value={this.state.diaFin}
                                                    type="select" 
                                                    name="diaFin" 
                                                    id="diaFin">
                                                      <option selected disabled>Seleccione un Dia</option>
                                                      {days.map((e,i) => {
                                                        return <option className='text-capitalize' value={i+1}>{e}</option>
                                                      })}
                                                    </Input>
                                                </FormGroup>
                                    </Col>
                                    <Col className="pl-md-1" md="3">
                                      <FormGroup>
                                        <Label for={`horaInicio`}>inicio</Label>
                                        <Input 
                                        onChange={this.handleChange} 
                                        value={this.state.horaInicio}
                                        type="time"
                                        name={`horaInicio`} 
                                        id={`horaInicio`}>
                                        </Input>
                                      </FormGroup>
                                    </Col>
                                    <Col className="pl-md-1" md="3">
                                    <FormGroup>
                                      <Label for={`horaFin`}>Cierre</Label>
                                      <Input 
                                      onChange={this.handleChange} 
                                      value={this.state.horaFin}
                                      type="time" 
                                      name={`horaFin`} 
                                      id={`horaFin`}>
                                      </Input>
                                    </FormGroup>
                                    </Col>
                                    <Col className="pl-md-1" md="3">
                                      <Button onClick={this.handleAddDays.bind(this)} size='sm' type='button' color='primary' >
                                        Agregar Rango de dias
                                      </Button>
                                    </Col>
                                    
                                  </Row>
                                  
                      </Col>
                    
                  </Row>
                  <Row className='m-0'>
                    <Col className='border rounded border-primary p-3 m-1'> 
                    
                    {this.state.newHorario[this.state.temporada] && Object.entries(this.state.newHorario[this.state.temporada]).map(([key, value]) => {
                          const [inicio,fin] = key.split('_')
                          //debugger
                          return <Row>
                            <Col md={4}>
                              <p className='mb-2'>{inicio === fin ? `${objDays[inicio]}` :
                              `de ${objDays[inicio]} a ${objDays[fin]}`
                              }</p>
                            </Col>
                            <Col md={4}>
                              <p className='mb-0'>Inicio: {value.start}</p>
                              <p className='mb-1'>Fin: {value.end}</p>
                            </Col>
                            <Col md={4}>
                            <Button size="sm" type='button' onClick={() => {
                              const horariosCopy = {...this.state.newHorario}
                              delete horariosCopy[this.state.temporada][key]

                              //debugger
                              this.setState({newHorario: horariosCopy})
                            }}>Eliminar Horas</Button>
                            </Col>
                          </Row>
                        })}
                    
                    </Col>
                  </Row>
          {/*----------------------------------------------mapa------------------------------*/}
                  <Row>
                    <Col className="pr-md-1" md="6">
                    
                    <FormGroup>
                      <Label for="lat">Latitud</Label>
                      <Input 
                      onChange={this.handleChangeNumber} 
                      value={this.state.lat}
                      type="text" 
                      name="lat" 
                      id="lat">
                      </Input>
                    </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="6">
                    <FormGroup >
                      <Label for="lon">Longitud</Label>
                      <Input 
                      onChange={this.handleChangeNumber} 
                      value={this.state.lon}
                      type="text" 
                      name="lon" 
                      id="lon">
                      </Input>
                    </FormGroup>
                    </Col>
                  </Row>
                    <Row>
                  <Col md="12">
                    <Card className="card-plain">
                      <CardBody>
                        <div
                          style={{ position: "relative", overflow: "hidden", height:'400px' }}
                        >
                          <div style={{
                            position: 'absolute',
                            top: 'calc(50% - 40px)',
                            left: 'calc(50% - 12px)',
                            height: '40px',
                            width: '24px',
                            background: 'transparent',
                            fontSize:'30px',
                            zIndex: 1,
                            }}><FontAwesomeIcon color='#106ad4' icon='map-marker-alt'></FontAwesomeIcon></div>
                          <MapLocation classNameInput='citySearch' lngLat={{lng: this.state.lon, lat: this.state.lat}} handleLonLat={this.handleLonLat} />
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  </Row>
          <FormGroup>
            <Label for="color">Color</Label>
            <Input 
                      className='p-0'
              onChange={this.handleChange} 
              type="select" 
              name="classes" 
              id="color">
                <option selected disabled>Seleccione un color</option>
                {
                  Object.entries(colorsDisp).map(([key, value]) => {
                    return <option className='text-capitalize' value={value}>{key}</option>
                  })
                }
              </Input>
          </FormGroup>
          <FormGroup>
            <Label for="location">Ciudad</Label>
            <Input
              onChange={this.handleChangeCity}
              value={this.state.location}
              invalid= {this.state.errors.location}
              autoComplete='off'
              type="search"
              name="location"
              id="location"
              placeholder="Seleccione una ubicacion de las posibles opciones"
            />
              <FormFeedback> la ciudad no es Valida</FormFeedback>
            <Collapse isOpen={this.state.isOpen}>
            <Card>
                <CardBody className='p-0'>
                <ul style={{zIndex: 300}} className='optionsSearch'> 
                    {(this.state.location.length > 3) && this.state.cities.map(e => {
                        const place = `${e.city}, ${e.state}, ${e.country}`
                        return (
                        <li onClick={() => {this.Handleclick(place, e._id)}}>{place}</li>
                    )})}
                </ul>
                </CardBody>
              </Card>
            </Collapse>
          </FormGroup>
          {(this.state.selectedCities.length >0) && <Row>
                <ul > 
                    {this.state.selectedCities.map((e,i) => {
                        const place = `${e.fullName}`
                        return (
                        <li><p className='m-0'>{place}</p>
                        <button style={{
                          fontSize: '10px',
                          border: 'none',
                          borderRadius: '5px',
                          color:'white',
                          backgroundColor: 'rgb(51, 88, 244)'

                        }} onClick={() => {this.handleDeleteCity(i)}} type='button'>Eliminar</button>
                        </li>
                    )})}
                </ul>
          </Row>}
          {/*---------------------------------------------precios------------------------------------------*/}
          <Row className='justify-content-center m-0'>
                    <Col xs={12} md={12} lg={12}><h2>Precios</h2></Col>
                    <Col xs={4}>
                      <FormGroup>
                          <Label for={`priceType`}>Tipo De Moneda</Label>
                          <Input 
                          style={{
                            fontWeight:'600',
                            color:'white'
                          }}
                          className='text-center p-0'
                            onChange={this.handleChange} 
                            value={this.state.priceType}
                            type="text" 
                            name="priceType" 
                            id={`priceType`}>
                            </Input>
                        </FormGroup></Col>
                      <Col xs={12} md={12} lg={12} key={`${this.state.temporada}-key`} className='border rounded border-primary p-3 m-1'> 
                                <h2 className='m-0 text-capitalize'>Precios</h2>
                                  
                                <Row className='m-0'>
                    
                                    <Col className="pl-md-1" md="3">
                                    <FormGroup>
                                                  <Label for={`tempPriceName`}>Nombre</Label>
                                                  <Input 
                                                    onChange={this.handleChange} 
                                                            className='p-0'
                                                    value={this.state.tempPriceName}
                                                    type="text" 
                                                    name="tempPriceName" 
                                                    id={`tempPriceName`}>
                                                    </Input>
                                                </FormGroup>
                                    </Col>
                                    <Col className="pl-md-1" md="3">
                                    <FormGroup>
                                                  <Label for={`tempPriceName`}>Nombre ingles</Label>
                                                  <Input 
                                                    onChange={this.handleChange} 
                                                            className='p-0'
                                                    value={this.state.tempPriceNameEn}
                                                    type="text" 
                                                    name="tempPriceNameEn" 
                                                    id={`tempPriceNameEn`}>
                                                    </Input>
                                                </FormGroup>
                                    </Col>
                                    <Col className="pl-md-1" md="2">
                                    <FormGroup>
                                                  <Label for={`tempPriceCost`}>Precio</Label>
                                                  <Input 
                                                    onChange={this.handleChangeNumber} 
                                                            className='p-0'
                                                    value={this.state.tempPriceCost}
                                                    type="text" 
                                                    name="tempPriceCost" 
                                                    id="tempPriceCost">
                                                    </Input>
                                                </FormGroup>
                                    </Col>
                                    <Col md='6' className='border rounded border-primary p-3 m-1'> 
                    
                                      {Object.entries(this.state.prices).map(([key, value]) => {
                                            //debugger
                                            return <Row>
                                              <Col md={4}>
                                                <p className='mb-2'>{key}</p>
                                              </Col>
                                              <Col md={4}>
                                                <p className='mb-0'>costo: {value}</p>
                                              </Col>
                                              <Col md={4}>
                                              <Button size="sm" type='button' onClick={() => {
                                                const pricesCopy = {...this.state.prices}
                                                delete pricesCopy[key]
                                                this.setState({prices: pricesCopy})
                                              }}>Eliminar</Button>
                                              </Col>
                                            </Row>
                                          })}
                                      
                                      </Col>
                                    <Col md='6' className='border rounded border-primary p-3 m-1'> 
                    
                                      {Object.entries(this.state.pricesEn).map(([key, value]) => {
                                            //debugger
                                            return <Row>
                                              <Col md={4}>
                                                <p className='mb-2'>{key}</p>
                                              </Col>
                                              <Col md={4}>
                                                <p className='mb-0'>costo: {value}</p>
                                              </Col>
                                              <Col md={4}>
                                              <Button size="sm" type='button' onClick={() => {
                                                const pricesCopy = {...this.state.pricesEn}
                                                delete pricesCopy[key]
                                                this.setState({pricesEn: pricesCopy})
                                              }}>Eliminar</Button>
                                              </Col>
                                            </Row>
                                          })}
                                      
                                      </Col>
                                      <Col className="pl-md-1" md="3">
                                      <Button onClick={() => {
                                        
                                        const pricesCopy = {...this.state.prices}
                                        const pricesEnCopy = {...this.state.pricesEn}
                                        pricesCopy[this.state.tempPriceName] = this.state.tempPriceCost
                                        pricesEnCopy[this.state.tempPriceNameEn] = this.state.tempPriceCost
                                        this.setState({
                                          prices: pricesCopy,
                                          pricesEn: pricesEnCopy,
                                          tempPriceName:'',
                                          tempPriceNameEn:'',
                                        })
                                      }} size='sm' className='mt-0' type='button' color='primary' >
                                        Agregar costo
                                      </Button>
                                    </Col>
                                  </Row>
                                  
                      </Col>
                    
                  </Row>
                  
            {/*--------------------------------------------------------tags------------------------------*/}
          <Row  xs={2} md={3} lg={4}>
            <Col xs={12} md={12} lg={12}><h2>Tags</h2></Col>

            {newTags}
          </Row>
          <ImageUploader titleImg={this.state.image} handleChangeImg={this.handleChangeImg} />
          {(this.state.urlImage || this.state.idImg) && <Row className='align-items-center justify-content-center' xs={2} md={3} lg={4}>
          <Col xs={12} md={12} lg={12}><h2>imagen Previa</h2></Col>
            <img alt='imagenAntigua' src={this.state.urlImage}></img>
          </Row>}
          <Row>
            <Col><Button disabled={this.state.disabled} color="primary" type="submit">
            Guardar
          </Button></Col>
            <Col>
            <Button onClick={this.props.onBack} disabled={this.state.disabled} color="danger" type="button">
            Volver
          </Button>
          </Col>
          </Row>

          
          
        </form>
      </CardBody>
    </Card>
          </Col>
        </Row>
      </div>
    </>
    )
  }
}
/*
{days.map((e,i) => {
                      return <Col key={`${e}-key`} className='border rounded border-primary p-3 m-1'> 
                                <h2 className='m-0 text-capitalize'>{e}<Input 
                                  className='m-1'
                                  checked={this.state.horarios[this.state.temporada][e].isOpen}
                                  onChange={(active) => {
                                   
                                    const newHorario = {horarios: {...this.state.horarios, [this.state.temporada]:{...this.state.horarios[this.state.temporada], [e] : {...this.state.horarios[this.state.temporada][e], isOpen : (active.target.value === 'true') }}}}
                                    this.setState(newHorario)}} 
                                  type="checkbox" 
                                  value={!this.state.horarios[this.state.temporada][e].isOpen}>
                                  </Input></h2>
                                  <FormGroup>
                                  <Label for={`${e}-inicio`}>inicio</Label>
                                  <Input 
                                  disabled={!this.state.horarios[this.state.temporada][e].isOpen}
                                  onChange={this.handleChangeHorario} 
                                  value={this.state.horarios[this.state.temporada][e].inicio}
                                  type="time" 
                                  name={`${e}-inicio`} 
                                  id={`${e}-inicio`}>
                                  </Input>
                                  <Label for={`${e}-cierre`}>Cierre</Label>
                                  <Input 
                                  disabled={!this.state.horarios[this.state.temporada][e].isOpen}
                                  onChange={this.handleChangeHorario} 
                                  value={this.state.horarios[this.state.temporada][e].cierre}
                                  type="time"
                                  name={`${e}-cierre`} 
                                  id={`${e}-cierre`}>
                                  </Input>
                                </FormGroup>
                              </Col>
                    })}
*/

export default FormAdminPlacesSection;
